// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICardPurseAccountValidityRangeDto } from './ICardPurseAccountValidityRangeDto';
import {
    ICardPurseAccountValidityRangeDtoFromJSON,
    ICardPurseAccountValidityRangeDtoFromJSONTyped,
    ICardPurseAccountValidityRangeDtoToJSON,
    ICardPurseAccountValidityRangeDtoToJSONTyped,
} from './ICardPurseAccountValidityRangeDto';

/**
 * 
 * @export
 * @interface ICardPurseAccountDto
 */
export interface ICardPurseAccountDto {
    /**
     * 
     * @type {number}
     * @memberof ICardPurseAccountDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardPurseAccountDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseAccountDto
     */
    status?: ICardPurseAccountDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseAccountDto
     */
    purse_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardPurseAccountDto
     * @deprecated
     */
    available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardPurseAccountDto
     * @deprecated
     */
    current_balance?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountDto
     * @deprecated
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountDto
     * @deprecated
     */
    valid_to?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountDto
     */
    valid_from_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountDto
     */
    valid_to_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof ICardPurseAccountDto
     */
    card_account_id?: number;
    /**
     * 
     * @type {Array<ICardPurseAccountValidityRangeDto>}
     * @memberof ICardPurseAccountDto
     */
    validity_ranges?: Array<ICardPurseAccountValidityRangeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseAccountDto
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseAccountDto
     */
    is_locked_by_health_plan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseAccountDto
     */
    is_locked_manually?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseAccountDto
     */
    is_locked_by_system?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseAccountDto
     */
    employee_unlock_forbidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseAccountDto
     */
    lock_reason?: ICardPurseAccountDtoLockReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICardPurseAccountDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN'
}
/**
* @export
* @enum {string}
*/
export enum ICardPurseAccountDtoLockReasonEnum {
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DOCUMENTATION_REQUIRED = 'DOCUMENTATION_REQUIRED',
    FRAUD_DETECTED = 'FRAUD_DETECTED',
    CARDHOLDERS_REQUEST = 'CARDHOLDERS_REQUEST'
}


/**
 * Check if a given object implements the ICardPurseAccountDto interface.
 */
export function instanceOfICardPurseAccountDto(value: object): value is ICardPurseAccountDto {
    return true;
}

export function ICardPurseAccountDtoFromJSON(json: any): ICardPurseAccountDto {
    return ICardPurseAccountDtoFromJSONTyped(json, false);
}

export function ICardPurseAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardPurseAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'purse_name': json['purse_name'] == null ? undefined : json['purse_name'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'current_balance': json['current_balance'] == null ? undefined : json['current_balance'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'valid_from_date': json['valid_from_date'] == null ? undefined : (new Date(json['valid_from_date'])),
        'valid_to_date': json['valid_to_date'] == null ? undefined : (new Date(json['valid_to_date'])),
        'card_account_id': json['card_account_id'] == null ? undefined : json['card_account_id'],
        'validity_ranges': json['validity_ranges'] == null ? undefined : ((json['validity_ranges'] as Array<any>).map(ICardPurseAccountValidityRangeDtoFromJSON)),
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'is_locked_by_health_plan': json['is_locked_by_health_plan'] == null ? undefined : json['is_locked_by_health_plan'],
        'is_locked_manually': json['is_locked_manually'] == null ? undefined : json['is_locked_manually'],
        'is_locked_by_system': json['is_locked_by_system'] == null ? undefined : json['is_locked_by_system'],
        'employee_unlock_forbidden': json['employee_unlock_forbidden'] == null ? undefined : json['employee_unlock_forbidden'],
        'lock_reason': json['lock_reason'] == null ? undefined : json['lock_reason'],
    };
}

export function ICardPurseAccountDtoToJSON(json: any): ICardPurseAccountDto {
    return ICardPurseAccountDtoToJSONTyped(json, false);
}

export function ICardPurseAccountDtoToJSONTyped(value?: ICardPurseAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_id': value['account_id'],
        'status': value['status'],
        'purse_name': value['purse_name'],
        'available_balance': value['available_balance'],
        'current_balance': value['current_balance'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'valid_from_date': value['valid_from_date'] == null ? undefined : ((value['valid_from_date']).toISOString().substring(0,10)),
        'valid_to_date': value['valid_to_date'] == null ? undefined : ((value['valid_to_date']).toISOString().substring(0,10)),
        'card_account_id': value['card_account_id'],
        'validity_ranges': value['validity_ranges'] == null ? undefined : ((value['validity_ranges'] as Array<any>).map(ICardPurseAccountValidityRangeDtoToJSON)),
        'deleted': value['deleted'],
        'is_locked_by_health_plan': value['is_locked_by_health_plan'],
        'is_locked_manually': value['is_locked_manually'],
        'is_locked_by_system': value['is_locked_by_system'],
        'employee_unlock_forbidden': value['employee_unlock_forbidden'],
        'lock_reason': value['lock_reason'],
    };
}

